import React, { useMemo, useState } from "react";
import "../css/profile.css";
import Logo from "../assets/images/01hire-logo.svg";
import Chat from "../assets/images/chat.svg";
import TestCenter from "../assets/images/testCenter.svg";
import JobOffers from "../assets/images/jobOffers.svg";
import { useAppDispatch, useAppSelector } from "../store/store";
import { useNavigate } from "react-router-dom";
import SimplePopperNotification from "./PopOverNotification";
import SimplePopperProfile from "./PopOverProfile";
import { SELECTED_NAV_OPTION } from "../constants/stringConstants";
import { setNavOption } from "../reducers/commonReducer";

function Navbar() {
  const { isUserProfileComplete } = useAppSelector((state) => state["user"]);
  const { selectedNavbarOption } = useAppSelector((state) => state["common"]);


  // console.log({selectedNavbarOption})
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const memoizedPopperNotification = useMemo(
    () => <SimplePopperNotification />,
    []
  );


  return (
    <div className="profile__navbar">
      <div className="header__logo">
        <img src={Logo} alt="01hire-logo" />
      </div>
      {isUserProfileComplete && (
        <>
          <div className="navbar_routes">
            <div
              className="navbar_routes_item"
              onClick={() => {
                dispatch(setNavOption(SELECTED_NAV_OPTION.JOBS));
                navigate("/");
              }}
            >
              <img src={JobOffers} className="navbar_routes_item_icon" />
              <text
                style={{
                  color:
                    selectedNavbarOption === SELECTED_NAV_OPTION.JOBS
                      ? "blue"
                      : "black",
                }}
              >
                My Jobs
              </text>
            </div>

            <div
              className="navbar_routes_item"
              onClick={() => {
                dispatch(setNavOption(SELECTED_NAV_OPTION.CHATS));
                navigate("/chats");
              }}
            >
              <img src={Chat} className="navbar_routes_item_icon" />
              <text
                style={{
                  color:
                    selectedNavbarOption === SELECTED_NAV_OPTION.CHATS
                      ? "blue"
                      : "black",
                }}
              >
                Chats
              </text>
            </div>

            <div
              className="navbar_routes_item"
              onClick={() => {
                dispatch(setNavOption(SELECTED_NAV_OPTION.INTERVIEWS));
                navigate("/interviews");
              }}
            >
              <img src={JobOffers} className="navbar_routes_item_icon" />
              <text
                style={{
                  color:
                    selectedNavbarOption === SELECTED_NAV_OPTION.INTERVIEWS
                      ? "blue"
                      : "black",
                }}
              >
                Interviews
              </text>
            </div>
            <div
              className="navbar_routes_item"
              onClick={() => {
                dispatch(setNavOption(SELECTED_NAV_OPTION.TEST_CENTER));
                navigate("/testCenter");
              }}
            >
              <img src={TestCenter} className="navbar_routes_item_icon" />
              <text
                style={{
                  color:
                    selectedNavbarOption === SELECTED_NAV_OPTION.TEST_CENTER
                      ? "blue"
                      : "black",
                }}
              >
                Test Center
              </text>
            </div>
          </div>
          <div className="navbar_user_notification_profile">
            <div>{memoizedPopperNotification}</div>

            <div>
              <SimplePopperProfile />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Navbar;
